import type { KeyboardEvent } from "react";

// The Contacts/Addresses sections render inside CounterpartyForm's <form>, whose
// footer button is a real submit. Their search inputs pass
// `searchKeyboardShortcuts={false}`, so SearchFilter no longer blurs on Enter —
// pressing Enter in the search box would implicitly submit the counterparty form,
// saving/creating it and closing the editor mid-edit. Block Enter coming from a
// search input so only the explicit footer action submits.
export const preventSearchImplicitSubmit = (
    event: KeyboardEvent<HTMLElement>,
) => {
    if (event.key === "Enter" && event.target instanceof HTMLInputElement) {
        event.preventDefault();
    }
};
